import React, {SyntheticEvent, useEffect} from 'react';
import {WebSnippetProfile} from "../Helpers/Types";
import {useSnippetContext} from "../Utils/UseSnippetContext";
import {snippetAuth} from "../Utils/SnippetAuth";
import useGetAlert from "../Utils/UseGetAlert";
import useServiceUrls from "../Utils/UseServiceUrls";
import SnippetHeader from "../Helpers/SnippetHeader";
import SnippetFooter from "../Helpers/SnippetFooter";
import useAcknowledgeAlert from "../Utils/UseAcknowledgeAlert";
import {Button} from "@material-ui/core";
import LoadingSpinner from "../LoadingSpinner";
import {closeWindow} from "../Helpers/Functions";

type AlertSnippetProps = {
    profile: WebSnippetProfile
}

export default function AlertSnippet(props: AlertSnippetProps) {
    // @ts-ignore
    const { domain, deviceCode, cartUid, cartExternalId, cartSourceExternalId, lineUid, alertUid, onCompleteFunction, snippetSessionKey } = useSnippetContext();
    const auth = snippetAuth(snippetSessionKey, cartUid, domain, deviceCode)
    const { serviceUrls } = useServiceUrls(domain);
    const {alert, alertStatus, alertError} = useGetAlert(serviceUrls, domain, deviceCode, alertUid)
    
    const [acknowledgeAlert, {status: acknowledgeStatus, error}] = useAcknowledgeAlert()

    useEffect(() => {
        async function callOnComplete() {
            try {
                // @ts-ignore
                await window[onCompleteFunction]();
            } catch (e) {
                console.log(`On complete function ${onCompleteFunction} not found`)
            }
        }
        
        if (acknowledgeStatus === 'success') {
            callOnComplete();
            closeWindow()
        }
    }, [acknowledgeStatus])
    
    const acknowledge = (e: SyntheticEvent) => {
        e.preventDefault()
        acknowledgeAlert({urls: serviceUrls, auth, alertUid})
    }
    
    return (
        <div className='bLoyal-center'>
            <SnippetHeader logoUrl={props.profile.LogoUrl} title={props.profile.Title} message={props.profile.Message} snippetCode={props.profile.Code}/>
            {alert && <p>{`${alert.Message}${alert.Detail ? `: ${alert.Detail}` : ''}`}</p>}
            <Button onClick={acknowledge} >OK</Button>
            {alertStatus === 'loading' && <LoadingSpinner />}
            {alertError && <p className='bLoyal-error-text'>{alertError}</p>}
            <SnippetFooter footer={props.profile.Footer} snippetCode={props.profile.Code}/>
        </div>
    )
}